import "./layout/theme"
import "./sections/featured-collection"
import "./sections/footer"
import "./sections/header"
import "./sections/login-register"
import "./sections/wishlist"
import "./templates/cart"
import "./templates/collection"
import "./templates/gift_card"
import "./templates/index"
import "./templates/page.dl-content"
import "./templates/page.wishlist"
import "./templates/product"
import "./templates/search"
import "./templates/customers/account"
import "./templates/customers/addresses"
import "./templates/customers/order"
import "./templates/customers/reset_password"
import { load } from "@shopify/theme-sections"

load('*');
